import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5469638a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "symbols-picker-content" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

import ModalBase from "../ui/modals/modal-base.vue";
import { computed } from "vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";


export default /*#__PURE__*/_defineComponent({
  __name: 'symbol-selector-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when a symbol is selected.
   * Passes the selected icon as a parameter to the parent component.
   */
  "symbolSelected",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: Boolean) => emit("update:modelValue", value),
});

const addIconTotText = (icon: string) => {
  emit("symbolSelected", icon);
  showModal.value = false;
};

const firstRowSymbols = [" ", '"', "¡", "¢", "£", "¤", "¥", "¦", "§", "©"];
const secondRowSymbols = ["¨", "ª", "«", "¬", "®", "¯", "°", "±", "²", "³"];
const thirdRowSymbols = ["´", "µ", "¶", "·", "¸", "¹", "º", "»", "¼", "½"];
const fourthRowSymbols = ["¾", "¿", "×", "Ø", "÷", "ø", "ƒ", "ˆ", "˜", "–"];
const fithRowSymbols = ["—", "‘", "’", "‚", "“", "”", "„", "†", "‡", "•"];
const sixthRowSymbols = ["…", "‰", "‹", "›", "€", "™", "À", "Á", "Â", "Ã"];
const seventhRowSymbols = ["Ä", "Å", "Æ", "Ç", "È", "É", "Ê", "Ë", "Ì", "Í"];
const eigthRowSymbols = ["Î", "Ï", "Ð", "Ñ", "Ò", "Ó", "Õ", "Ô", "Ö", "×"];
const ninthRowSymbols = ["Ø", "Ù", "Ú", "Û", "Ü", "Ý", "Þ", "ß", "à", "á"];
const tenthRowSymbols = ["â", "ã", "ä", "å", "æ", "ç", "è", "é", "ê", "ë"];
const elventhRowSymbols = ["ì", "í", "î", "ï", "ð", "ñ", "ò", "ó", "ô"];
const twelthRowSymbols = ["õ", "ö", "÷", "ø", "ù", "ú", "û", "ü", "ý", "þ"];
const thirteenthRowSymbols = ["ÿ", "Œ", "œ", "Š", "š", "Ÿ", "¢", "Ω", "@"];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    title: "Symbols",
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    showCloseButton: true,
    width: _unref(ModalWidth).XSmall
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(firstRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_2)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(secondRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_3)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(thirdRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_4)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fourthRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_5)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fithRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_6)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sixthRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_7)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(seventhRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_8)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(eigthRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_9)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ninthRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_10)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tenthRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_11)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(elventhRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_12)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(twelthRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_13)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(thirteenthRowSymbols, (symbol, index) => {
                return _createElementVNode("td", {
                  key: index,
                  onClick: ($event: any) => (addIconTotText(symbol))
                }, [
                  _createElementVNode("div", null, _toDisplayString(symbol), 1)
                ], 8, _hoisted_14)
              }), 64))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})